import 'intersection-observer'

import Vue from 'vue'
import AOS from 'aos'
import VueRouter from 'vue-router'
import VueScrollActive from 'vue-scrollactive'

import './app.css'

// Components
import chatbot from '@/components/ChatBot'
import parallaxScroll from './components/ParallaxScoll'
import buttonRipple from './components/ButtonRipple'
import GtmTracking from './components/GtmTracking'
import heroSlider from './components/HeroSlider'

import ProductInformationExpand from './components/products/ProductInformationExpand'

import Picture from './components/Picture.vue'
import MainMenu from './components/MainMenu.vue'
import Slider from './components/Slider.vue'
import VideoOverlayTrigger from './components/VideoOverlayTrigger.vue'
import VideoOverlay from './components/VideoOverlay.vue'
import MediaBlock from './components/MediaBlock.vue'
import CookieBanner from './components/CookieBanner.vue'
import YoutubeVideo from './components/YoutubeVideo.vue'
import AdimoWidget from './components/AdimoButton.vue'
import Video from './components/Video.vue'

import RecipesOverview from './components/recipes/RecipesOverview.vue'
import RecipeIngredients from './components/recipes/RecipeIngredients.vue'
import RecipeNavBar from './components/recipes/NavigationBar.vue'
import RecipeCookMode from './components/recipes/RecipeCookMode.vue'
import SoMeGrid from './components/SoMeGrid.vue'

import ProductsOverview from './components/products/ProductsOverview.vue'
import vueUtil from './vue-utils'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueScrollActive)

const components = {
  Picture,
  MainMenu,
  Slider,
  VideoOverlayTrigger,
  VideoOverlay,
  MediaBlock,
  CookieBanner,
  RecipesOverview,
  RecipeIngredients,
  RecipeNavBar,
  RecipeCookMode,
  SoMeGrid,
  ProductsOverview,
  YoutubeVideo,
  AdimoWidget,
  Video
}

vueUtil.mountComponents(components)

// Init scripts
buttonRipple()
parallaxScroll()
GtmTracking()
chatbot()
heroSlider()

ProductInformationExpand()

AOS.init()
